<div>
  <form class="drawer-form-wrapper" [formGroup]="optionsForm">
    <div formGroupName="generalOptions" class="options-group">
      <h3>General Options</h3>
      <div *ngFor="let option of generalOptions">
        <label
          nz-checkbox
          for="option{{ option.id }}"
          [formControlName]="option.id.toString()"
          class="checkbox-group"
          [nzDisabled]="!isEditMode">
          {{ option.label }}
        </label>
      </div>
    </div>

    <div formGroupName="developmentAreas" class="options-group">
      <h3>Development Areas</h3>
      <div class="development-areas-wrapper">
        <div *ngFor="let area of developmentAreas">
          <label
            nz-checkbox
            for="area{{ area.id }}"
            [formControlName]="area.id.toString()"
            class="checkbox-group"
            [nzDisabled]="!isEditMode">
            {{ area.label }}
          </label>
        </div>
      </div>
    </div>
    <div class="display-flex drawer-footer option-footer">
      <div class="footer-left" *ngIf="!isEditMode">
        <button
          type="button"
          type="button"
          nz-button
          [nzType]="'primary'"
          class="btn"
          [nzLoading]="isUpdating"
          [disabled]="loading || isUpdating"
          (click)="enableEdit()">
          Edit
        </button>
      </div>

      <div class="footer-right" *ngIf="isEditMode">
        <button
          type="button"
          nz-button
          [nzType]="'default'"
          class="btn"
          (click)="onCancel()"
          (key.enter)="onCancel()">
          Cancel
        </button>
        <button
          type="button"
          type="button"
          nz-button
          [nzType]="'primary'"
          class="btn"
          [nzLoading]="isUpdating"
          [disabled]="loading || isUpdating"
          *ngIf="isEditMode"
          (click)="onSubmit()">
          Save
        </button>
      </div>
    </div>
  </form>
</div>
